// extracted by mini-css-extract-plugin
export default {"PostLoadAnim":"styles_PostLoadAnim__rRqWf","LoadTile":"styles_LoadTile__9SSf3","fadeA":"styles_fadeA__LNzxY","fadeB":"styles_fadeB__nDSpH"};